
export const env = {
  googleApiKey: process.env.REACT_APP_GOOGLE_API_KEY
}

export const color = {
  mainColor: '#F48C8D',
  bgcolor: '#ffffee',
}